import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

import { reactive } from 'vue';

import RenderInput from './components/RenderInput.vue';
import RenderSelect from './components/RenderSelect.vue';
import RenderTextarea from './components/RenderTextarea.vue';
import RenderValidate from './components/RenderValidate';


const __default__ = {
  name: 'FieldRender',
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['item'],
  emits: ['handle'],
  setup(__props, { emit: emits }) {

const props = __props;



const state = reactive({
  
})

function fieldHandle(data) {
  emits('handle', data)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.item.formType === 'textarea')
      ? (_openBlock(), _createBlock(RenderTextarea, _mergeProps({
          key: 0,
          item: props.item
        }, _ctx.$attrs), null, 16, ["item"]))
      : (props.item.formType === 'select')
        ? (_openBlock(), _createBlock(RenderSelect, _mergeProps({
            key: 1,
            item: props.item
          }, _ctx.$attrs), null, 16, ["item"]))
        : (props.item.formType === 'validate')
          ? (_openBlock(), _createBlock(_unref(RenderValidate), _mergeProps({
              key: 2,
              item: props.item
            }, _ctx.$attrs, { onHandle: fieldHandle }), null, 16, ["item"]))
          : (_openBlock(), _createBlock(RenderInput, _mergeProps({
              key: 3,
              item: props.item
            }, _ctx.$attrs), null, 16, ["item"]))
  ]))
}
}

})